import { Filter, FilterTypes } from "@madhive/mad-sdk";

// RecipeFilters type definition (matching mad-sdk internal type)
interface RecipeFilters {
  /** Recipe ID or array of IDs to filter by */
  id?: string | string[];
  /** Whether to load the boolean expression in the response (reduces payload size when false) */
  loadBoolExpr?: boolean;
  /** Whether to fetch org-specific recipe preferences */
  fetchPreferred?: boolean;
}

/**
 * Filters for minimal recipes (excludes boolean expressions)
 * Matches mad-web/packages/core/mad-sdk/src/lib/modules/recipes/constants.ts MINIMAL_RECIPE_FILTERS
 */
export const MINIMAL_RECIPE_FILTERS: Filter<RecipeFilters> = {
  where: [
    {
      type: FilterTypes.EQ,
      value: false,
      field: "loadBoolExpr"
    }
  ]
};

/**
 * Filters for default/full recipes (includes boolean expressions and preferred flag)
 * Combines loadBoolExpr and fetchPreferred for complete recipe data
 */
export const DEFAULT_RECIPE_FILTERS: Filter<RecipeFilters> = {
  where: [
    {
      type: FilterTypes.EQ,
      value: true,
      field: "loadBoolExpr"
    },
    {
      type: FilterTypes.EQ,
      value: true,
      field: "fetchPreferred"
    }
  ]
};
